'use es6';

import { createSelector } from 'reselect';
import { MAX_EMAIL_WIDTH, MIN_COLUMN_PIXEL_WIDTH, MAX_COLUMN_WIDTH } from 'EmailEditorUI/utils/moduleUtils';
import { getBodyBorderWidth, getLayoutSettings } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { getIsSectionBoxedHelper } from 'EmailEditorUI/redux/selectors/sectionSelectors';
import { getIsSingleColumnFullWidth } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { getIsDraggingWithinApp, getDraggedItemType } from 'LayoutBuilderUI/selectors/userInterface';
import { RESIZE_HANDLE } from 'LayoutBuilderUI/lib/DragDropConstants';
import { basicSelectorWithStats } from 'ContentEditorUI/redux/selectors/helpers';
export const getMaxBoxedBodyWidth = createSelector([getBodyBorderWidth], bodyBorderWidth => MAX_EMAIL_WIDTH - bodyBorderWidth * 2);
export const getResizeGraduationForSection = basicSelectorWithStats((state, sectionIndex) => {
  const isBoxed = getIsSectionBoxedHelper(getLayoutSettings(state), sectionIndex);
  const bodyWidth = isBoxed ? getMaxBoxedBodyWidth(state) : MAX_EMAIL_WIDTH;
  return bodyWidth / MAX_COLUMN_WIDTH;
});
export const getMinColumnWidthForGraduationSizeHelper = resizeGraduationSize => Math.ceil(MIN_COLUMN_PIXEL_WIDTH / resizeGraduationSize);
export const getCanAddNewColumnHelper = (numColumns, minColWidth) => {
  return numColumns < 4 && (numColumns + 1) * minColWidth <= MAX_COLUMN_WIDTH;
};
export const getShouldShowResizeHandles = createSelector([getIsSingleColumnFullWidth, getIsDraggingWithinApp, getDraggedItemType], (isSingleColumnFullWidth, isDragging, itemType) => {
  if (!isSingleColumnFullWidth) {
    if (isDragging) {
      return itemType === RESIZE_HANDLE;
    }
    return true;
  }
  return false;
});